import PropertyPanelAccordion from 'containers/PropertyPanel/components/PropertyPanelAccordion';
import * as S from 'containers/PropertyPanel/PropertyPanel.styles';
import { CheckboxWithLabel } from 'components/CheckboxWithLabel';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { DisplayGraphMode } from 'store/units/types';
import { useEditFlowProperties } from '../useEditFlowProperties';

import type { FlowPropertiesProps } from '../withFlowProperties';
import { withFlowProperties } from '../withFlowProperties';

type Props = FlowPropertiesProps & {
  isFeed: boolean;
};

const Display = ({ id, activeUnit, flowProperties, isFeed }: Props) => {
  const { isStorage, setValue } = useEditFlowProperties(
    id,
    activeUnit,
    flowProperties,
  );

  const {
    pxxOne,
    pxxTwo,
    pxxThree,
    graphMode,
    sizeMode,
    pxxMode,
    display: {
      displayGraph,
      displaySizeGradation,
      displayPxxGradation,
      displayPxxValue1,
      displayPxxValue2,
      displayPxxValue3,
      displaySize,
      displayNormalMassFlow,
      displayBulkDensity,
      displayWorkIndex,
      displayAbrasionIndex,
      displayClay,
      displayMoisture,
    },
  } = flowProperties;

  return (
    <PropertyPanelAccordion title='Display' defaultExpanded>
      <S.CheckBoxContainer>
        <CheckboxWithLabel
          value={displayPxxGradation}
          setValue={(val) => setValue(['display', 'displayPxxGradation'], val)}
          label={`Pxx gradation`}
        />
        {displayPxxGradation && (
          <S.CheckBoxContainer indent>
            {!isStorage && !isFeed && (
              <RadioGroup
                value={pxxMode}
                onChange={(e) => setValue('pxxMode', e.target.value)}
              >
                <FormControlLabel
                  value={DisplayGraphMode.DISCHARGE_ONLY}
                  control={<Radio size='small' color='info' />}
                  label='Discharge only'
                />
                <FormControlLabel
                  value={DisplayGraphMode.FEED_AND_DISCHARGE}
                  control={<Radio size='small' color='info' />}
                  label='Feed and discharge'
                />
              </RadioGroup>
            )}

            <CheckboxWithLabel
              value={displayPxxValue1}
              setValue={(val) => setValue(['display', 'displayPxxValue1'], val)}
              label={`Value 1 (${pxxOne} %)`}
            />
            <CheckboxWithLabel
              value={displayPxxValue2}
              setValue={(val) => setValue(['display', 'displayPxxValue2'], val)}
              label={`Value 2 (${pxxTwo} %)`}
            />
            <CheckboxWithLabel
              value={displayPxxValue3}
              setValue={(val) => setValue(['display', 'displayPxxValue3'], val)}
              label={`Value 3 (${pxxThree} %)`}
            />
          </S.CheckBoxContainer>
        )}
        {!isFeed && <S.Line />}
        {!isFeed && (
          <CheckboxWithLabel
            value={displaySizeGradation}
            setValue={(val) =>
              setValue(['display', 'displaySizeGradation'], val)
            }
            label={`Size gradation`}
          />
        )}
        {displaySizeGradation && (
          <S.CheckBoxContainer indent>
            {!isStorage && !isFeed && (
              <RadioGroup
                value={sizeMode}
                onChange={(e) => setValue('sizeMode', e.target.value)}
              >
                <FormControlLabel
                  value={DisplayGraphMode.DISCHARGE_ONLY}
                  control={<Radio size='small' color='info' />}
                  label='Discharge only'
                />
                <FormControlLabel
                  value={DisplayGraphMode.FEED_AND_DISCHARGE}
                  control={<Radio size='small' color='info' />}
                  label='Feed and discharge'
                />
              </RadioGroup>
            )}
            <CheckboxWithLabel
              value={displaySize}
              setValue={(val) => setValue(['display', 'displaySize'], val)}
              label={`Size`}
            />
            <CheckboxWithLabel
              value={displayNormalMassFlow}
              setValue={(val) =>
                setValue(['display', 'displayNormalMassFlow'], val)
              }
              label={`Flow rate`}
            />
            <CheckboxWithLabel
              value={displayBulkDensity}
              setValue={(val) =>
                setValue(['display', 'displayBulkDensity'], val)
              }
              label={`Bulk density`}
            />
            <CheckboxWithLabel
              value={displayWorkIndex}
              setValue={(val) => setValue(['display', 'displayWorkIndex'], val)}
              label={`Work index`}
            />
            <CheckboxWithLabel
              value={displayAbrasionIndex}
              setValue={(val) =>
                setValue(['display', 'displayAbrasionIndex'], val)
              }
              label={`Abrasion index`}
            />
            <CheckboxWithLabel
              value={displayClay}
              setValue={(val) => setValue(['display', 'displayClay'], val)}
              label={`Clay`}
            />
            <CheckboxWithLabel
              value={displayMoisture}
              setValue={(val) => setValue(['display', 'displayMoisture'], val)}
              label={`Moisture`}
            />
          </S.CheckBoxContainer>
        )}
        {!isFeed && <S.Line />}
        {!isFeed && (
          <CheckboxWithLabel
            value={displayGraph}
            setValue={(val) => setValue(['display', 'displayGraph'], val)}
            label={`Graph`}
          />
        )}
        {displayGraph && !isStorage && !isFeed && (
          <S.CheckBoxContainer indent>
            <RadioGroup
              value={graphMode}
              onChange={(e) => setValue('graphMode', e.target.value)}
            >
              <FormControlLabel
                value={DisplayGraphMode.DISCHARGE_ONLY}
                control={<Radio size='small' color='info' />}
                label='Discharge only'
              />
              <FormControlLabel
                value={DisplayGraphMode.FEED_AND_DISCHARGE}
                control={<Radio size='small' color='info' />}
                label='Feed and discharge'
              />
            </RadioGroup>
          </S.CheckBoxContainer>
        )}
      </S.CheckBoxContainer>
    </PropertyPanelAccordion>
  );
};

export default withFlowProperties(Display);
